export const ASSETS = {
  logo: "/smhss-crest.png",
  corridor: "https://customer-assets-jai6qajn.emergentagent.net/job_smhss-chennai/artifacts/11bzfw04_PHOTO-2026-03-05-14-29-18.webp",
  library: "https://customer-assets-jai6qajn.emergentagent.net/job_smhss-chennai/artifacts/o81jiuf0_PHOTO-2026-03-05-14-29-19.webp",
  classroom: "https://customer-assets-jai6qajn.emergentagent.net/job_smhss-chennai/artifacts/l1f3z1fe_PHOTO-2026-03-05-14-29-20.webp",
  building: "https://customer-assets-jai6qajn.emergentagent.net/job_smhss-chennai/artifacts/bbup5o26_PHOTO-2026-03-05-14-29-24.webp",
  courtyard: "https://customer-assets-jai6qajn.emergentagent.net/job_smhss-chennai/artifacts/6708561j_PHOTO-2026-03-05-14-29-23.webp",
};

export const LINKS = {
  tel: "tel:+914424867105",
  mobile: "tel:+917604838880",
  whatsapp: "https://wa.me/917604838880",
  email: "mailto:sathyaschool1989@gmail.com",
  directions: "https://maps.app.goo.gl/EJzoxQesRSh5RViz5",
  mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.9907341064!2d80.1713034768691!3d13.03626161345371!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52613400000001%3A0xe746f83221a897a3!2sSathya%20Matriculation%20Hr%20Sec%20School!5e0!3m2!1sen!2sin!4v1787195928884!5m2!1sen!2sin",
};
